import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";


@NgModule({
  declarations: [
/*
    DealersComponent,
    DealerSearchCriteriaComponent,
    ReviewDialogComponent,

    ContractsComponent,
    ContractDialogComponent,
    ContractModificationDialogComponent,
    
    CarSearchCriteriaComponent,
    CarSearchCriteriaVerticalComponent,
    
    CarCardComponent, 
    CarCardHorizontalComponent,
    CarBoxComponent,
    CarBoxListComponent,
    CarCardListComponent,
    
    CarEditDialogComponent,

    ProviderOffersComponent,
    ProviderOfferDialogComponent,

    KeepOffersComponent,
    KeepOfferDialogComponent,

    CarCardSellerComponent, 
    CarCardBuyerComponent,
    
    ProviderOfferCardSellerComponent,
    
    TableDialogComponent,
    SelectDialogComponent,

    CarSearchComponent,
    CarDetailsComponent,
    CarCardAccountComponent,

    DealerSearchComponent,

    ProposalsComponent,
    ProposalDialogComponent,

    BookingsComponent,
    BookingDialogComponent,
    BookingEditComponent,

    JobsComponent,
    JobDialogComponent,
    JobItemDialogComponent,
    
    JobSearchCriteriaComponent,

    AlertsComponent,
    NotificationsComponent,
 
    AppointmentsComponent,
    AppointmentDialogComponent,
    //AppointmentsSectionComponent,

    ConversationsComponent,
    ConversationDialogComponent,
    MessageDialogComponent,

    ImageCarouselComponent,
    BranchesGoogleMapComponent
*/
  ],

  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatSliderModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatTableModule,
    MatDividerModule,
    MatProgressBarModule,
   
    MatDialogModule,

    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,

    MatBadgeModule,
    MatExpansionModule,

    MatDatepickerModule,
    MatNativeDateModule,

    MatSlideToggleModule,

    MatTooltipModule,

    GoogleMapsModule,

    OverlayModule
  ],

  exports: [
/*
    DealersComponent,
    DealerSearchCriteriaComponent,
    ReviewDialogComponent,

    ContractsComponent,
    ContractDialogComponent,
    ContractModificationDialogComponent,
    
    CarSearchCriteriaComponent,
    CarSearchCriteriaVerticalComponent,
    
    CarCardComponent, 
    CarCardHorizontalComponent,
    CarBoxComponent,
    CarBoxListComponent,
    CarCardListComponent,
    
    CarEditDialogComponent,

    ProviderOffersComponent,
    ProviderOfferDialogComponent,

    KeepOffersComponent,
    KeepOfferDialogComponent,

    CarCardSellerComponent, 
    CarCardBuyerComponent,

    ProviderOfferCardSellerComponent,
    
    TableDialogComponent,
    SelectDialogComponent,

    CarSearchComponent,
    CarDetailsComponent,
    CarCardAccountComponent,

    DealerSearchComponent,

    ProposalsComponent,
    ProposalDialogComponent,

    BookingsComponent,
    BookingDialogComponent,
    BookingEditComponent,

    JobsComponent,
    JobDialogComponent,
    JobItemDialogComponent,
    JobSearchCriteriaComponent,
 
    AppointmentsComponent,
    AppointmentDialogComponent,
    //AppointmentsSectionComponent,

    AlertsComponent,
    NotificationsComponent,

    ConversationsComponent,
    ConversationDialogComponent,
    MessageDialogComponent,

    ImageCarouselComponent,
    BranchesGoogleMapComponent
    */
  ]
})

export class SharedModule { }
